<template>
  <v-card flat class="py-4" :color="opaque ? null : 'transparent'">
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" class="text-center">
          <v-progress-circular :indeterminate="true" color="grey darken-2" />
        </v-col>
        <v-col cols="12" class="text-center">
          <p class="text-caption mt-2 mb-0 grey--text text--darken-2">{{ $t(message) }}</p>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: 'VLoading',
  props: {
    opaque: { type: Boolean, default: false },
    message: { type: String, default: 'pleaseWait' }
  }
}
</script>

<i18n>
{
  "en": {
    "pleaseWait": "Please Wait"
  },
  "fr": {
    "pleaseWait": "Veuillez patienter"
  }
}
</i18n>
